import apiClient from './apiClient';

class CompanyContextService {
  // Get active company context
  async getCompanyContext() {
    try {
      const response = await apiClient.get('/api/company-context');
      return response.success ? response.data : null;
    } catch (error) {
      console.error('Failed to get company context:', error);
      return null;
    }
  }

  // Update company context
  async updateCompanyContext(contextData) {
    try {
      const response = await apiClient.put('/api/company-context', contextData);
      
      if (response.success) {
        return response.data;
      }
      
      throw new Error(response.message || 'Failed to update company context');
    } catch (error) {
      console.error('Failed to update company context:', error);
      throw error;
    }
  }
}

export default new CompanyContextService();